import React from 'react';
import { Control, Controller, RegisterOptions, get } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

type CustomTextFieldProps = TextFieldProps & {
  errors?: Record<string, any>;
  control: Control<any>;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
  defaultValue?: unknown;
  name: string;
  helperText?: string;
};

export const CustomSelectField: React.FC<CustomTextFieldProps> = ({
  errors,
  name,
  control,
  children,
  defaultValue,
  rules,
  helperText,
  ...rest
}) => {
  const error = get(errors, name);
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      name={name}
      render={({ field: { ref, value, ...field } }) => (
        <TextField
          {...field}
          value={value ?? ''}
          inputRef={ref}
          error={Boolean(error)}
          helperText={error?.message || helperText}
          fullWidth
          select
          variant="outlined"
          {...rest}
        >
          {children}
        </TextField>
      )}
    />
  );
};
